import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
// @material-ui/icons components
// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import boxShadows from "assets/theme/box-shadow.js";

const GridView = () => {
  const theme = useTheme();
  return (
    <>
      <SimpleHeader section="Grid" subsection="Components" />
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        sx={{
          marginTop: "-4.5rem",
          [theme.breakpoints.up("md")]: {
            paddingLeft: "30px",
            paddingRight: "30px",
          },
        }}
      >
        {/* Table */}
        <Grid
          container
          component={Box}
          sx={{ marginBottom: "39px", justifyContent: "center" }}
        >
          <Grid item xs={12} lg={8}>
            <Card sx={{ boxShadow: boxShadows.boxShadow + "!important" }}>
              <CardHeader
                sx={{ backgroundColor: "initial" }}
                title="Grid system"
                titleTypographyProps={{
                  component: Box,
                  sx: { marginBottom: "0!important" },
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Grid container>
                  <Grid item xs={12} sm={4}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      One of three columns
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      One of three columns
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      One of three columns
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Card sx={{ boxShadow: boxShadows.boxShadow + "!important" }}>
              <CardHeader
                sx={{ backgroundColor: "initial" }}
                title="Equal-width"
                titleTypographyProps={{
                  component: Box,
                  sx: { marginBottom: "0!important" },
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Grid container>
                  <Grid item xs={6}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      1 of 3
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      2 of 3
                    </Box>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={3}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      1 of 3
                    </Box>
                  </Grid>
                  <Grid item xs={3}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      2 of 3
                    </Box>
                  </Grid>
                  <Grid item xs={3}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      3 of 3
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Card sx={{ boxShadow: boxShadows.boxShadow + "!important" }}>
              <CardHeader
                sx={{ backgroundColor: "initial" }}
                title="Setting one column width"
                titleTypographyProps={{
                  component: Box,
                  sx: { marginBottom: "0!important" },
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Grid container>
                  <Grid
                    item
                    component={Box}
                    sx={{ flexBasis: "0", flexGrow: "1", maxWidth: "100%" }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      1 of 3
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      2 of 3 (wider)
                    </Box>
                  </Grid>
                  <Grid
                    item
                    component={Box}
                    sx={{ flexBasis: "0", flexGrow: "1", maxWidth: "100%" }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      3 of 3
                    </Box>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid
                    item
                    component={Box}
                    sx={{ flexBasis: "0", flexGrow: "1", maxWidth: "100%" }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      1 of 3
                    </Box>
                  </Grid>
                  <Grid item xs={5}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      2 of 3 (wider)
                    </Box>
                  </Grid>
                  <Grid
                    item
                    component={Box}
                    sx={{ flexBasis: "0", flexGrow: "1", maxWidth: "100%" }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      3 of 3
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Card sx={{ boxShadow: boxShadows.boxShadow + "!important" }}>
              <CardHeader
                sx={{ backgroundColor: "initial" }}
                title="Variable width content"
                titleTypographyProps={{
                  component: Box,
                  sx: { marginBottom: "0!important" },
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Grid
                  container
                  component={Box}
                  sx={{ justifyContent: "center" }}
                >
                  <Grid item xs={12} lg={2}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      1 of 3
                    </Box>
                  </Grid>
                  <Grid item xs={12} md="auto">
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      Variable width content
                    </Box>
                  </Grid>
                  <Grid item xs={12} lg={2}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      3 of 3
                    </Box>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid
                    item
                    component={Box}
                    sx={{ flexBasis: "0", flexGrow: "1", maxWidth: "100%" }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      1 of 3
                    </Box>
                  </Grid>
                  <Grid item md="auto">
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      Variable width content
                    </Box>
                  </Grid>
                  <Grid item xs={12} lg={2}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      3 of 3
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Card sx={{ boxShadow: boxShadows.boxShadow + "!important" }}>
              <CardHeader
                sx={{ backgroundColor: "initial" }}
                title="Equal-width multi-row"
                titleTypographyProps={{
                  component: Box,
                  sx: { marginBottom: "0!important" },
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Grid container>
                  <Grid
                    item
                    component={Box}
                    sx={{ flexBasis: "0", flexGrow: "1", maxWidth: "100%" }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      col
                    </Box>
                  </Grid>
                  <Grid
                    item
                    component={Box}
                    sx={{ flexBasis: "0", flexGrow: "1", maxWidth: "100%" }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      col
                    </Box>
                  </Grid>
                  <Box sx={{ width: "100%" }}></Box>
                  <Grid
                    item
                    component={Box}
                    sx={{ flexBasis: "0", flexGrow: "1", maxWidth: "100%" }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      col
                    </Box>
                  </Grid>
                  <Grid
                    item
                    component={Box}
                    sx={{ flexBasis: "0", flexGrow: "1", maxWidth: "100%" }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      col
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Card sx={{ boxShadow: boxShadows.boxShadow + "!important" }}>
              <CardHeader
                sx={{ backgroundColor: "initial" }}
                title="Mix and match"
                titleTypographyProps={{
                  component: Box,
                  sx: { marginBottom: "0!important" },
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Grid container>
                  <Grid item xs={12} md={8}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      {"xs={12} md={8}"}
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      {"xs={12} md={4}"}
                    </Box>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={6} md={4}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      {"xs={6} md={4}"}
                    </Box>
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      {"xs={6} md={4}"}
                    </Box>
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      {"xs={6} md={4}"}
                    </Box>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={6}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      {"xs={6}"}
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        padding: ".75rem",
                        fontSize: ".875rem",
                        margin: "1rem 0",
                        color: theme.palette.gray[800],
                        borderRadius: ".25rem",
                        boxShadow: boxShadows.boxShadow + "!important",
                        backgroundColor: theme.palette.white.main,
                        border: "1px solid " + theme.palette.gray[300],
                      }}
                    >
                      {"xs={6}"}
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default GridView;
